import isUserLoggedIn from "@Middleware/isUserLoggedIn"

const TeamDomainPurchaseController = () =>
  import("@Modules/shoppingcart/Controllers/TeamDomainPurchaseController.vue")

export default function PurchaseRoutes() {
  return [
    {
      path: ":org/purchase/domain",
      name: "org.purchase.domain",
      component: TeamDomainPurchaseController,
      meta: { middleware: [isUserLoggedIn], navbarEnabled: true },
    },
  ]
}
